export default __webpack_public_path__ + "static/media/bio_logo.900a24a9.png";